import { Grid, useTheme } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import RkdCard from "../../app/component/card/RkdCard";
import SystemTreeSelector from "../../app/component/features/SystemTreeSelector";
import useHeight from "../../app/hook/useHeight";
import { useStore } from "../../app/stores/store";
import RAMTable from "./RAMTable/RAMTable";

function RAMIndex() {
    const { commonStore, assetStore } = useStore();
    const theme = useTheme()
    const { height, ref } = useHeight()
    
    useEffect(() => {
        commonStore.setTitlePage("RAM Analysis");
    });

    useEffect(() => {
        assetStore.setCardHeight(height)
    }, [height, assetStore])
    
    return (
        <RkdCard ref={ref}>
            <Grid container spacing={2}>
                <Grid 
                    sx={{
                        borderRight: `1px solid ${theme.palette.grey[200]}`,
                        pr: 2
                    }} 
                    item 
                    xs={4}
                >
                    <SystemTreeSelector/>
                </Grid>
                <Grid item xs={8}>
                    <RAMTable/>
                </Grid>
            </Grid>
        </RkdCard>
    );
}

export default observer(RAMIndex);